import React from "react"
import * as Timespan from "./Timespan"
import {Dropdown} from "../../../components"
import DayPicker from "react-day-picker"
import moment from "moment"
import {Popover, PopoverBody} from "reactstrap"
import { CSSTransition } from 'react-transition-group'
import RenderToPortal from '../../../components/portals/RenderToPortal';
import { ANGULAR_FILTERS } from '../../../modules/app/navigator/navigatorPortalNames';

export class ScoreDateRangeSelector extends React.Component {

  constructor(props) {
    super(props)
    const {timespans, start, end} = this.props
    const roundedStart = moment(start).startOf('day')
    const roundedEnd = moment(end).startOf('day')
    this.state = {
      selection: Timespan.findTimespan(timespans || Timespan.DEFAULTS)(roundedStart, roundedEnd)
    }

    this.onStartChanged = this.onStartChanged.bind(this)
    this.onEndChanged = this.onEndChanged.bind(this)
  }

  onStartChanged(start) {
    const {onChange, end} = this.props
    const newEnd = end.isSameOrBefore(start) ? moment(start).utc().add(1, 'day') : end
    onChange && onChange({ start: start.utc().startOf('day'), end: newEnd })
  }
  onEndChanged(end) {
    const {onChange, start} = this.props
    const newStart = end.isSameOrBefore(start) ? moment(end).utc().subtract(1, 'day') : start
    onChange && onChange({ start: newStart, end: end.endOf('day') })
  }

  render() {
    const {timespans, start, end, onChange, className, ...props} = this.props
    const {today, selection} = this.state
    const rangeSelected = selection === Timespan.RANGE

    return <RenderToPortal id={ANGULAR_FILTERS}><div
      className={`score-date-range-selector ${className || ''}`}
      {...props}>
      <Dropdown
        items={timespans || Timespan.DEFAULTS}
        renderItem={Timespan.renderTimespan}
        selected={selection}
        onSelected={newSelection => {
          if (newSelection !== Timespan.RANGE) {
            const {start, end} = Timespan.toDateRange(newSelection)
            this.setState({selection: newSelection})
            onChange && onChange({start, end})
          } else {
            this.setState({selection: newSelection})
          }
        }}
      />
      {rangeSelected && <div className="d-flex flex-column w-100">
        <DateButton
          date={start}
          className="range-button"
          style={{
            marginTop: "7px"
          }}
          maxDate={moment().utc().subtract(1, 'day')}
          onChange={this.onStartChanged}
        />
        <DateButton
          className="range-button"
          style={{
            marginTop: "7px"
          }}
          date={end}
          maxDate={moment().utc()}
          onChange={this.onEndChanged}
        />
      </div>}
    </div>
    </RenderToPortal>
  }



}

const Animated = ({ children, isVisible }) => {
    return <CSSTransition
      mountOnEnter={true}
      in={isVisible}
      classNames="range-button"
      timeout={{ enter: 250, exit: 250 }}
    >{children}</CSSTransition>

}

class DateButton extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      show: false,
    }
    this.hide = this.hide.bind(this)
    this.toggle = this.toggle.bind(this)
  }
  hide() {
    this.setState({show: false})
  }
  toggle() {
    this.setState({show: !this.state.show})
  }
  render() {
    const { show } = this.state
    const { date, onChange, maxDate, ...props } = this.props
    return <span {...props} id="scoreDateRangePop">
      <span
        ref="target"
        className="btn btn-secondary btn-block"
        onClick={this.toggle}
      >{
        date.calendar(null, {
          lastDay: '[Yesterday]',
          sameDay: '[Today]',
          lastWeek: '[Last] dddd',
          sameElse: 'L'
        })
      }
      </span>
      <Popover
        placement="left"
        isOpen={show}
        target={"scoreDateRangePop"}
        id="selector"
        boundariesElement="window">
          <PopoverBody className="p-0">
            <DayPicker
              selectedDays={date && moment(date).toDate()}
              disabledDays={x => !!maxDate && moment(x).isAfter(maxDate)}
              onDayClick={(date) => {
                this.hide()
                onChange(moment(date))
              }}
            />
          </PopoverBody>
      </Popover>
    </span>
  }
}
